import { DOCUMENT } from '@angular/common';
import { inject, Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FaviconService {
    private document = inject(DOCUMENT);

    getFavicon(): string {
        const link = this.document.querySelector<HTMLLinkElement>("link[rel*='icon']");
        return link?.href ?? '';
    }

    setFavicon(url: string): void {
        let link = this.document.querySelector<HTMLLinkElement>("link[rel*='icon']");
        if (!link) {
            link = this.document.createElement('link');
            link.rel = 'icon';
            this.document.head.appendChild(link);
        }
        link.href = url;
    }
}
